import React from 'react';
import { Button } from '@seccl/ui';
import Link from 'next/link';

import { ClarityContext } from '../../context/clarity.context';
import { routes } from '../../routes';

import styles from './consentBanner.module.scss';

export const ConsentBanner: React.FC = () => {
  const { consentIsKnown, clarityIsInitialised, giveConsent, declineConsent } = React.useContext(ClarityContext);

  if (consentIsKnown || !clarityIsInitialised) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.actions}>
          <Button onClick={giveConsent}>Accept analytics</Button>
          <Button onClick={declineConsent}>Reject analytics</Button>
        </div>

        <div className={styles.policy}>
          <p>
            <Link href={routes.cookies.root}>Cookie Policy</Link>
          </p>
        </div>
      </div>
    </div>
  );
};
